export const ADMIN = "ADMIN"; //Administrador
export const ADMINNOABM = "ADMINNOABM"; //Administrador Sin ABMs
export const SUP = "SUP"; //Supervisor
export const MAQ = "MAQ"; //Maquinista
export const MEC = "MEC"; //Mecánico
export const SOCIO = "SOCIO"; //Socio
export const CANCHERO = "CANCHERO"; //Canchero (solo visualiza Grilla Disponibilidad)
export const GESTOR_RESERVAS = "GESTOR_RESERVAS"; //Gestor de Reservas
export const REV = "REV"; //Gestor de Reservas
export const REVISOR_RESERVAS = "REVISOR_RESERVAS"; //Revisor de Reservas (solo visualiza Reservas de Canchas)
